/**
 * Ensure value returned is a number
 * @param  {Number} n  a number object
 * @return {Number}    ensured number
 */
export default function ensureNumber (n) {
  return !isNaN(n) ? Number(n || 0) : 0
}



// WEBPACK FOOTER //
// ./modules/utils/ensureNumber.js